import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueFormIssueCategory', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/issue-category/issue-category.html'),
        controller: 'CompanyConfigurationCategoriesController',
        controllerAs: 'CompanyConfigurationCategoriesCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            category: '=',
            company: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/issue-category/issue-category.component.ts